import script from "./CommentThread.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentThread.vue?vue&type=script&setup=true&lang=js"

import "./CommentThread.vue?vue&type=style&index=0&id=2763002f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2763002f"]])

export default __exports__